import assetsExplorerModule from '../assetsExplorerModule';

const assetsExplorerComponent = {
  templateUrl: 'assets-explorer',
  bindings: {
    userId: '<',
    assetsPager: '<',
    assets: '<',
    currentData: '<',
    pageType: '<',
    showCreatorName: '<',
    categories: '<'
  },
  controller: 'assetsExplorerController'
};

assetsExplorerModule.component('assetsExplorer', assetsExplorerComponent);
export default assetsExplorerComponent;
